module.exports = __webpack_public_path__ + "media/images/aloe/illustrations/error1-0c7afbd7e1d964bdd6ae70d86396c8f3.svg";